import { FeaturedProducts } from 'ui/components/3-organisms/FeaturedProducts';
import { getProductById, getProductBySku, updateBasket } from 'application/repositories/ecommerceRepository';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import { DictionaryContext } from 'application/adapters/context/Dictionary';
import { useDispatch, useSelector } from 'react-redux';
import { currentCustomer } from 'application/adapters/store/slices/customerSlice';
import { currency, currentCartId, setCart } from 'application/adapters/store/slices/cartSlice';
import { LocaleContext } from 'application/adapters/context/LocaleContext';
import formatCartPrices from 'helpers/formatCartPrices';

export const FeaturedProductsFeature = ({ content, accessToken, culture }) => {
	const { title, productsPicker } = content?.properties ?? {};
	const productIds = productsPicker?.split(',');
	const [mappedProducts, setMappedProducts] = useState([]);
	const { status } = useSession();
	const dictionary = useContext(DictionaryContext);
	const featuredProductsDictionary = {
		loadMore: dictionary.getValue('FeaturedProducts.LoadMore', null, 'Load more products'),
		confirmAddedToCart: dictionary.getValue('ShoppingCart.ConfirmAddedToCart', null, 'Item added to cart'),
	};
	const businessPartner = useSelector(currentCustomer);
	const basketId = useSelector(currentCartId);
	const dispatch = useDispatch();
	const localeContext = useContext(LocaleContext);
	const currencyCode = useSelector(currency);
	const mapProducts = useCallback(async () => {
		if (productIds?.length > 0) {
			const products = await Promise.all(
				productIds.map(async (id: string) => {
					let product = null;
					if (id.length > 30) {
						product = await getProductById(id, accessToken, culture, businessPartner?.id);
					} else {
						product = await getProductBySku(id, accessToken, culture, businessPartner?.id);
					}

					if (!product) {
						return null;
					} else {
						return {
							...product,
							price: {
								...product?.price,
								formattedPrice: localeContext.formatPrice(product?.price?.price, product?.price?.currencyCode),
							},
						};
					}
				}),
			);
			setMappedProducts(products.filter((p) => p != null));
		}
	}, [productIds, accessToken, culture]);

	useEffect(() => {
		mapProducts();
	}, [businessPartner?.id]);

	const handleAddProductToCart = (cartProduct) => {
		updateBasket(
			accessToken,
			{
				basketId,
				cultureCode: culture,
				bpId: businessPartner?.id,
				...cartProduct,
			},
			false,
			true,
		)
			.then((res) => {
				dispatch(setCart(formatCartPrices(res, localeContext, currencyCode)));
			})
			.catch((err) => {
				console.error(err);
				alert('Error adding product to cart');
			});
	};

	return (
		<FeaturedProducts
			numberOfProducts={mappedProducts?.length}
			products={mappedProducts}
			isLoggedIn={status === 'authenticated'}
			heading={title}
			columns={5}
			confirmAddedToCartText={featuredProductsDictionary.confirmAddedToCart}
			loadMoreText={featuredProductsDictionary.loadMore}
			handleAddProductToCart={handleAddProductToCart}
			hasBp={businessPartner?.id ? true : false}
		/>
	);
};
